import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { logger } from './utils/logger';

// Filter out MetaMask errors from appearing in the console
const originalError = logger.error;
logger.error = (...args) => {
  const message = args.join(' ');
  // Don't show MetaMask-related errors since they're not relevant to our app
  if (message.includes('MetaMask') || message.includes('metamask') || message.includes('ethereum')) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Trigger rebuild 2026-01-06 00:00:24
